$(document).ready(function(){ 
  if(location.pathname == '/cart'){ 
    setTimeout(function(){
      $('html, body').animate({
            scrollTop: 14
        }, 'slow'); 
      }, 2000) 
  }
  
   let isOpen=false;$(window).scroll(function(event) {
      var scroll=$(window).scrollTop();
      
      if(scroll>10&&!isOpen) {
        if(location.pathname == '/cart' && window.yett){ 
          yett.unblock();
        } 
        isOpen=true;
        
        if(location.href.includes("cart")){}
        var sectionImage=$(".custom-img");
    
        Array.from(sectionImage).forEach(function(element){
          let elementSrc=element.dataset.src
          $(element).attr("src",elementSrc);
        });  
      }
    });
  // set up css var for starting app height. this will not change on resize so we can avoid the jumpy scroll issue
  const appHeight = () => {
    document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`)
  };
  document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`)
   window.addEventListener('orientationchange', appHeight);
});
